import { TextOperatorType } from "src/app/models/text-operator";
import { SelectOperatorType } from "src/app/models/select-operator";
import { GeneralOperatorType } from "src/app/models/general-operator";
import { NumericOperatorType } from "./numeric-operator";

export class Determinant {
  public id: string;
  public service: string;
  public serviceId: string;
  public name: string;
  public registrationKey: string;
  public registrationLocationKey: string;
  public type: string;
  public determinantType = "QUESTION";
  public targetFormFieldKey: string;
  public targetGridFieldKey: string;
  public gridFieldType: string;
  public targetFormFieldJsonPath: string;
  public fieldNumber: string;
  public sourceFormFieldKey: string;
  public classificationField: any;
  public value: any;
  public bots: any;
  public registrationId: string;
  public eventComponent: string = null;
  public eventName: string = null;
  public generated: boolean = false;
  public usages: any = [];
  public subject: any = null;
  public status: boolean = true;
  public determinantInsideGrid: boolean = false;
  public gdbCatalogSelectedValue: string;
  public gdbCatalogFieldId: string;
  public gdbCatalogValue: any;
  public operator: GeneralOperatorType | TextOperatorType | NumericOperatorType | SelectOperatorType = GeneralOperatorType.EQUAL;
  public textOperator: TextOperatorType = TextOperatorType.EQUAL;
  public selectOperator: SelectOperatorType = SelectOperatorType.EQUAL;
  public classificationOperator: SelectOperatorType = SelectOperatorType.EQUAL;
  // used for form validation
  public valid: boolean;
  public deletedWhen?: string;
  // used to flag duplicate determinants
  public isDuplicate: boolean = false;
  public duplicateNames: string[] = [];
}
